export const WHITE_PRINT_ADD = {
  name: '백색인쇄추가',
  bp_option_group_name: '백색인쇄추가',
  dependency_bp_option_group_name: '재질',
};

const NESS_CHARACTER_INFO = 'NESS_CHARACTER_INFO';
export const SOG_NESS_CHARACTER_FRAME = {
  NESS_CHARACTER_INFO,
  BP_OPTION_GROUP_NESS_FRAME: 'NESS_FRAME',
  BP_OPTION_GROUP_NESS_CHARACTERS: 'NESS_CHARACTERS',
  BP_OPTION_NESS_FRAME_NOT_SELECTED: 'NESS_FRAME_NOT_SELECTED',
  HAS_NESS_CHARACTER_IN_FRAME: (selected_option_group) =>
    selected_option_group?.details?.type === NESS_CHARACTER_INFO,
  hasNotFrame: (bp_options) =>
    bp_options?.some(
      ({ dev_name }) => dev_name === SOG_NESS_CHARACTER_FRAME.BP_OPTION_NESS_FRAME_NOT_SELECTED,
    ),
  getCharacterLength: (selected_option_group) =>
    selected_option_group?.details?.value?.frame_characters?.length || 0,
};
